module.exports = __webpack_public_path__ + "img/a7.bac44078.png";